import {
  Dialog,
  DialogTitle,
  Stack,
  Box,
  Card,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import React, { useEffect, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getBuyerIndividualData } from 'api/apiService';
import { poppins400, poppins600 } from 'theme/common.style';
import { CardActionArea } from '@mui/material';
import { getApiCall } from 'api/apiService';
import { GET_BINDERID, USER_TYPE } from 'constant/app.config';
import Moxochat from 'component/Moxochat/Moxochat';
import { Phn, Msg } from './Marketplaceicons';
import noPhotoAvailableImage from 'assets/images/noPhotoAvailableImage.png';
import ScaledDialogContent from 'component/Common/ScaledDialogContent';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const MarketGallery = ({
  open,
  setOpen,
  openlogin,
  setOpenlogin,
  sharedpage,
  getBuyerIndividualValue,
}) => {
  // const [getBuyerIndividualValue, setGetBuyerIndividualValue] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const params = useParams();
  let propertyId = params?.propertyId;
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const currentUrl = window.location.href;

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.up('md'));

  // const getBuyerData = () => {
  //   getBuyerIndividualData(
  //     propertyId,
  //     currentUrl,
  //     userDetail?.primaryUserType
  //   ).then((res) => {
  //     if (res?.status == '1') {
  //       setGetBuyerIndividualValue(res);
  //     } else {
  //       setGetBuyerIndividualValue({});
  //     }
  //   });
  // };
  // useEffect(() => {
  //   getBuyerData();
  // }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  const buyerId = userDetail?.userId;
  const [currentBinder, setCurrentBinder] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const userType = userDetail?.primaryUserType;

  const directcomm = (agentId) => {
    if (buyerId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${buyerId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  const onShowChat = (binderId) => {
    setCurrentBinder(binderId);
    setModalIsOpen(true);
  };

  const handleMouseLeave = () => {
    setTimeout(() => {
      setIsHovered(false);
    }, 1500);
  };

  const ImageArray =
    getBuyerIndividualValue?.PropertyDetails?.propertyMedia?.filter((item) => {
      return item?.mediaType === 'Banner';
    }) ?? [];

  const propertyImages =
    ImageArray.map((item) => {
      return {
        original: item?.propertyMedia,
        thumbnail: item?.propertyMedia,
      };
    }) ?? [];

  const agentDetails = getBuyerIndividualValue?.PropertyDetails?.agentDetails;

  const firstNameInitial =
    agentDetails?.agentName?.charAt(0)?.toUpperCase() || '';
  const lastNameInitial =
    agentDetails?.agentSurName?.charAt(0)?.toUpperCase() || '';

  return (
    <Dialog
      fullScreen
      onKeyDown={handleKeyDown}
      open={open}
      TransitionComponent={Transition}
      container={() => document.getElementById('dialog-root')}
      sx={{ backgroundColor: 'black', zIndex: 1000 }}
      PaperProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          width: '100vw',
          height: '100vh',
          maxWidth: '100vw',
          maxHeight: '100vh',
          borderRadius: 0,
        },
      }}
    >
      <ScaledDialogContent>
        <>
          <DialogTitle>
            <Stack
              direction={'row'}
              justifyContent={'flex-start'}
              flexDirection={'row-reverse'}
              gap={{ md: 5 }}
              p={'5px 15px'}
            >
              <IconButton
                edge="start"
                onClick={() => setOpen(false)}
                aria-label="close"
              >
                <CloseIcon
                  sx={{
                    color: 'white',
                    fontSize: 30,
                    marginRight: {
                      xs: -6,
                      md: 0,
                    },
                  }}
                />
              </IconButton>
              <Box sx={{ md: { pr: 3 } }}>
                <Card
                  sx={{
                    display: 'flex',
                    marginLeft: '14px',
                    justifyContent: 'space-between',
                    minWidth: matchesmd ? '362px' : '300px',
                    height: '66px',
                    borderRadius: '33px 5px 5px 33px',
                    bgcolor: '#FFFFFF',
                    alignItems: 'center',
                    padding: '8px',
                    alignSelf: 'end',
                    flexDirection: 'row',
                    background: '#FFFFFF',
                    zIndex: 1,
                    gap: 3,
                  }}
                >
                  <Grid
                    sx={{
                      flexDirection: 'row',
                      display: 'flex',
                      gap: 2,
                    }}
                  >
                    <Grid>
                      {agentDetails?.agentProfile ? (
                        <img
                          src={agentDetails.agentProfile}
                          height="56px"
                          width="56px"
                          alt={`${agentDetails?.agentName} ${agentDetails?.agentSurName}`}
                          style={{
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            width: 56,
                            height: 56,
                            borderRadius: '50%',
                            bgcolor: '#666666',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '20px',
                            fontWeight: 400,
                            textTransform: 'uppercase',
                          }}
                        >
                          {firstNameInitial}
                          {lastNameInitial}
                        </Box>
                      )}
                    </Grid>
                    <Grid>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <Typography
                          sx={{
                            ...poppins600,
                            fontSize: !matchesmd ? '16px' : '20px',
                            color: '#6C2AD2',
                          }}
                        >
                          {`${getBuyerIndividualValue?.PropertyDetails?.agentDetails?.agentName} ${getBuyerIndividualValue?.PropertyDetails?.agentDetails?.agentSurName}`}
                        </Typography>
                        <Typography
                          sx={{
                            ...poppins400,
                            fontSize: matchesmd ? '12px' : '14px',
                            color: '#666666',
                          }}
                        >
                          Agent
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'end',
                      alignItems: 'center',
                    }}
                  >
                    <CardActionArea
                      sx={{
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        borderRadius: '5px',
                        padding: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '10px',
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (
                          sharedpage &&
                          (USER_TYPE === 'Buyer' || !USER_TYPE)
                        ) {
                          setOpenlogin(!openlogin);
                        } else {
                          directcomm(
                            getBuyerIndividualValue?.PropertyDetails
                              ?.agentDetails?.agentId
                          );
                        }
                      }}
                    >
                      <Msg />
                    </CardActionArea>
                    {modalIsOpen && (
                      <Moxochat
                        open={modalIsOpen}
                        onClose={setModalIsOpen}
                        binderId={currentBinder}
                        isgallery={true}
                      />
                    )}
                    <CardActionArea
                      variant="rounded"
                      sx={{
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        borderRadius: '5px',
                        padding: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={handleMouseLeave}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (
                          sharedpage &&
                          (USER_TYPE === 'Buyer' || !USER_TYPE)
                        ) {
                          setOpenlogin(!openlogin);
                        } else {
                          // localStorage.setItem(
                          //   'dialId',
                          //   getBuyerIndividualValue?.PropertyDetails?.agentDetails
                          //     ?.agentEmail
                          // );
                          // setShowMessage(true);
                          // setMessagedata({ incomingcall: true });
                          return window.open(
                            `tel:` +
                              getBuyerIndividualValue?.PropertyDetails
                                ?.agentDetails?.agentMobileNo
                          );
                        }
                      }}
                    >
                      <Phn />
                    </CardActionArea>
                  </Grid>
                </Card>
              </Box>
            </Stack>
          </DialogTitle>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              height: '100%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',

              '& .image-gallery': {
                width: '100%',
              },

              '& .image-gallery-slide': {
                height: '100%',
              },

              '& .image-gallery-slide img': {
                maxHeight: '100%',
                objectFit: 'contain',
                margin: 'auto',
              },
              '& .image-gallery-slide-wrapper': {
                height: matchesmd ? '100vh !important' : '70vh !important',
              },
            }}
          >
            <ImageGallery
              items={propertyImages}
              showPlayButton={false}
              showFullscreenButton={false}
              showIndex
              showBullets={false}
              lazyLoad
              onErrorImageURL={noPhotoAvailableImage}
            />
          </Box>
        </>
      </ScaledDialogContent>
    </Dialog>
  );
};

export default MarketGallery;
